import React, { useEffect, useState } from "react";
import { Input } from "antd";
import "./ListSearch.scss";

/**
 * One free-text search box, shared by every admin listing (DAB-880).
 *
 * Controlled by `value` so a page can keep it in sync with whatever it
 * persists the search term in (redux query state, component state, …) —
 * after paging, changing page size, refreshing or switching the BG/EN
 * content language, the box should still show the active term.
 *
 * Fires `onSearch` on Enter/the search button, and also on clear, so a page
 * only needs to handle one callback.
 */
export default function ListSearch({ value = "", onSearch, placeholder = "Търсене…", className = "" }) {
  const [text, setText] = useState(value);

  // Stay in sync when the parent's stored term changes from elsewhere
  // (e.g. a page refresh that resets the query, or navigating back).
  useEffect(() => {
    setText(value);
  }, [value]);

  const triggerSearch = (nextValue) => {
    onSearch((nextValue ?? "").trim());
  };

  return (
    <Input.Search
      allowClear
      className={`list-search ${className}`.trim()}
      placeholder={placeholder}
      value={text}
      onChange={(event) => {
        const next = event.target.value;
        setText(next);
        // The clear icon arrives here as a "click" change event, and antd has
        // already called onSearch("") for it — only a hand-emptied field
        // needs the search cleared from here.
        if (next === "" && event.type !== "click") {
          triggerSearch("");
        }
      }}
      onSearch={triggerSearch}
    />
  );
}
